
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinsupa() {



const cardData = {
  keyword: 'Cab Service in Supa MIDC',
  heading: 'eTravo: Trusted and Efficient Corporate Cab Services in Supa MIDC for Industrial Mobility',
  headingDescription: 'eTravo provides comprehensive and reliable corporate cab services in Supa MIDC, catering to the diverse transportation needs of industries, employees, and executives in this prominent industrial zone. Our services emphasize safety, punctuality, and comfort with GPS-enabled, air-conditioned vehicles and professional drivers. Whether it is daily employee commutes, executive transfers, or client visits, eTravo delivers scalable and customizable transport solutions to streamline your corporate mobility in Supa MIDC and nearby regions.',

  top: 'Key Industrial and Business Locations in Supa MIDC Covered by eTravo',
  topPlaces: [
    {
      title: 'Supa Industrial Estate',
      description: 'The core of Supa MIDC, home to numerous manufacturing and industrial companies. Our corporate cab services ensure smooth and timely transport for employees working across multiple shifts.'
    },
    {
      title: 'Automotive and Engineering Plants',
      description: 'Supa MIDC houses several automotive and engineering units requiring dependable staff transportation. eTravo provides seamless connectivity for workers and supervisors with tailored routes and schedules.'
    },
    {
      title: 'Logistics and Distribution Centers',
      description: 'Efficient transport solutions for logistics personnel managing goods movement within Supa MIDC, ensuring timely arrivals for operational continuity.'
    },
    {
      title: 'Warehousing Complexes',
      description: 'Our cab services support employees and management of warehousing hubs with comfortable and reliable transport to maintain productivity and punctuality.'
    },
    {
      title: 'Supa Bus Terminal and Transit Points',
      description: 'First-mile and last-mile connectivity for employees using public transport, bridging gaps in daily commutes for improved convenience.'
    },
    {
      title: 'Nearby Residential Localities',
      description: 'Connecting residential areas around Supa MIDC to industrial workplaces, promoting timely and hassle-free employee travel.'
    },
    {
      title: 'Training Facilities and Corporate Offices',
      description: 'Transporting staff and executives to training centers and offices within Supa MIDC for skill development and business operations.'
    },
    {
      title: 'Healthcare Centers and Emergency Services',
      description: 'Ensuring prompt and safe transport for employees and visitors accessing medical facilities in and around Supa MIDC.'
    },
    {
      title: 'Educational Institutes',
      description: 'Supporting travel needs of visiting trainers, interns, and corporate guests to educational institutions nearby.'
    },
    {
      title: 'Client Visit Locations',
      description: 'Providing professional and comfortable cab services for visiting clients, ensuring a positive impression and timely arrivals.'
    }
  ],

  services: [
    {
      name: 'Supa MIDC Corporate Cab Rentals',
      description: 'Tailored cab rental plans for businesses of all sizes, offering long-term contracts and flexible options to meet corporate transportation needs in Supa MIDC.'
    },
    {
      name: 'Employee Transport Cab Supa MIDC',
      description: 'Reliable daily and shift-based employee transport services equipped with GPS tracking and professional drivers to ensure safe and timely commutes.'
    },
    {
      name: 'Business Cab Services Supa MIDC',
      description: 'Diverse fleet options including sedans, SUVs, and executive vehicles to support business travel for owners, agents, and visiting clients.'
    },
    {
      name: 'Corporate Staff Cabs Supa MIDC',
      description: 'Efficient staff transportation solutions featuring multi-stop routes, shift schedules, and real-time tracking for operational efficiency.'
    },
    {
      name: 'Reliable Corporate Cab Service Supa MIDC',
      description: 'Committed to punctuality, cleanliness, and professionalism, providing dependable daily cab services to corporate clients.'
    },
    {
      name: 'AC Corporate Cabs Supa MIDC',
      description: 'All vehicles are fully air-conditioned, sanitized, and maintained to offer a comfortable travel environment suitable for all seasons.'
    },
    {
      name: 'Staff Pickup and Drop Cab Supa MIDC',
      description: 'Round-the-clock pickup and drop services catering to multiple shifts and departments, designed to reduce commute stress and improve productivity.'
    },
    {
      name: 'Affordable Business Cab Rentals Supa MIDC',
      description: 'Cost-effective transportation solutions with flexible billing, , and monthly contracts tailored for businesses seeking value without compromising quality.'
    },
    {
      name: 'Executive Cab Services Supa MIDC',
      description: 'Premium cab services with luxury vehicles and professional chauffeurs, perfect for executives, VIPs, and special corporate occasions.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Supa MIDC',
      description: 'Comprehensive monthly rental plans with route optimization, dedicated support, and real-time vehicle tracking for seamless transportation management.'
    },
    {
      name: 'Industrial Area Employee Transport Supa MIDC',
      description: 'End-to-end employee transport solutions designed for industrial shift patterns, including multi-stop pickups and drop-offs, ensuring safe and efficient commutes.'
    },
    {
      name: 'Corporate Client Cabs Supa MIDC',
      description: 'Professional and comfortable cab services for corporate client visits, business meetings, and hospitality, enhancing corporate reputation.'
    },
    {
      name: 'Business Meeting Cabs Supa MIDC',
      description: 'Flexible on-demand cab services for quick and convenient travel within Supa MIDC and nearby locations, ensuring responsiveness to business needs.'
    },
    {
      name: 'Supa Industrial Area Cab Hire',
      description: 'Dedicated cab hire services for staff commutes, inter-office travel, and special events, with scalable fleet options to meet varying requirements.'
    },
    {
      name: 'Corporate Shuttle Cabs Supa MIDC',
      description: 'Group shuttle services designed to transport teams efficiently between industrial units, offices, transit hubs, and residential areas within Supa MIDC.'
    }
  ],

  tableData: [
    ['Supa MIDC Corporate Cab Rentals', 'Employee Transport Cab Supa MIDC'],
    ['Business Cab Services Supa MIDC', 'Corporate Staff Cabs Supa MIDC'],
    ['Reliable Corporate Cab Service Supa MIDC', 'AC Corporate Cabs Supa MIDC'],
    ['Staff Pickup and Drop Cab Supa MIDC', 'Affordable Business Cab Rentals Supa MIDC'],
    ['Executive Cab Services Supa MIDC', 'Monthly Corporate Cab Rentals Supa MIDC'],
    ['Industrial Area Employee Transport Supa MIDC', 'Corporate Client Cabs Supa MIDC'],
    ['Business Meeting Cabs Supa MIDC', 'Supa Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Supa MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Comprehensive Corporate Cab Services for Supa MIDC",
        "WhyChoosedescription": "eTravo offers fully customized corporate cab services designed specifically for businesses operating in Supa Industrial Area MIDC. Understanding the unique logistical challenges of this industrial zone, we provide reliable, punctual, and comfortable transportation solutions that streamline employee commutes, reduce downtime, and enhance overall productivity. Our service aims to support companies in maintaining operational efficiency through seamless employee travel."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles Catering to Diverse Corporate Needs",
        "WhyChoosedescription": "Our extensive fleet includes sedans, SUVs, and MUVs, enabling companies to choose vehicles that match their specific transportation demands—be it daily employee commutes, executive travel, or team transfers within Supa MIDC and its surrounding areas. We prioritize comfort, safety, and efficiency across all vehicle options."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Expertise in Supa MIDC Routes",
        "WhyChoosedescription": "Our drivers are skilled professionals familiar with the roadways and traffic patterns in Supa MIDC and neighboring industrial zones. Their local knowledge ensures efficient route planning, timely pickups, and smooth rides, minimizing delays and enhancing the reliability of your corporate transportation."
    },
    {
        "WhyChooseheading": "Flexible Booking and Scheduling to Match Corporate Timelines",
        "WhyChoosedescription": "We offer flexible booking solutions tailored to corporate needs, including on-demand rides, scheduled pickups, and long-term contracts. This flexibility allows businesses to adjust transportation services according to fluctuating shift patterns, project deadlines, and employee requirements."
    },
    {
        "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
        "WhyChoosedescription": "All vehicles are equipped with advanced GPS tracking systems that enable real-time monitoring of rides. Corporate clients can track employee commutes live, ensuring safety, accountability, and the ability to respond quickly to any unforeseen events during transit."
    },
    {
        "WhyChooseheading": "Transparent Billing with Detailed Invoices for Easy Expense Management",
        "WhyChoosedescription": "Our billing system is straightforward and transparent, providing detailed invoices that include trip summaries, fare breakdowns, and any additional charges. This simplifies expense tracking, budget management, and reimbursement for corporate finance departments."
    },
    {
        "WhyChooseheading": "Strict Safety and Hygiene Standards for Passenger Wellbeing",
        "WhyChoosedescription": "Committed to passenger health and safety, we maintain rigorous hygiene protocols including regular vehicle sanitization, driver health checks, and adherence to mask mandates. These measures ensure a safe and comfortable travel environment for all employees."
    },
    {
        "WhyChooseheading": "Dedicated Account Managers Providing Personalized Corporate Support",
        "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who acts as a single point of contact for all transportation needs. This personalized support ensures efficient handling of bookings, quick resolution of queries, and customized service delivery tailored to your company’s requirements."
    }
]
}

const faqData = [
    [
        {
            question: "Which areas does your corporate cab service cover in Supa MIDC?",
            answer: "Our services cover Supa Industrial Area MIDC and nearby industrial zones, ensuring convenient transportation options for businesses in the region."
        },
        {
            question: "Can we schedule recurring rides for employees in Supa MIDC?",
            answer: "Yes, we offer options to schedule recurring rides to provide consistent and reliable transportation for your workforce."
        },
        {
            question: "Do you offer monthly billing for corporate clients?",
            answer: "Absolutely. We provide monthly billing with detailed invoices for easy expense tracking and management."
        },
        {
            question: "Are your drivers trained to maintain corporate professionalism?",
            answer: "Yes, our drivers undergo rigorous training to ensure they uphold professionalism, courtesy, and safety standards."
        },
        {
            question: "How do you ensure passenger safety during rides?",
            answer: "We implement GPS tracking, conduct regular vehicle maintenance, and enforce strict hygiene protocols including sanitization and mask usage."
        },
        {
            question: "Is dedicated support available for corporate clients in Supa MIDC?",
            answer: "Yes, corporate clients receive dedicated account management and support services for prompt assistance."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Amit Joshi",
        designation: "Operations Head, Apex Manufacturing",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s cab services in Supa MIDC have ensured our employees reach work on time with comfort and safety. Their professional approach is commendable.”"
    },
    {
        name: "Ms. Meera Kulkarni",
        designation: "HR Manager, BrightTech Industries",
        rating: [1, 1, 1, 1, 1],
        text: "“The personalized support and transparent billing from eTravo make them our trusted corporate transportation partner in Supa MIDC.”"
    }
];

























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Supa MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-supa-midc.jpg",
  "description": "Reliable corporate cab service in Supa MIDC for employee transport, business meetings, and industrial commutes. Affordable AC corporate cabs with trusted drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7832"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-supa-midc"
  }
};





    return (
        <div>

<Helmet>
  <title>Cab Service in Supa MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Supa MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinsupa;